<template>
  <div class="fullWidth">
    <!-- SHOWS ONLY WHERE CLIENT DID NOT ADD ANY TEAM MEMBERS YET -->
    <div v-if="cleanerInfo.length === 0" class="teamMembersEmpty">
      <br/>
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/team.svg" />
      </figure>
      
     <p><button class="add-btn" @click="$bvModal.show('register-cleaner')"> {{ $t('addCleaner') }}</button></p>               

      <b-modal id="register-cleaner" hide-footer>
          <template v-slot:modal-title>{{ $t('addCleaner') }}</template>
          <RegisterCleaner @success-add-cleaner="fetchCleaner"/>
        </b-modal>
      <!--END OF MODAL-->
    </div>

    <!-- SHOWS CLIENT ADD HIS FIRST TEAM MEMBER -->
    <div v-else class="teamMembersEntered">
      <div class="addBtnWrapper" @click="$bvModal.show('register-cleaner')">
        <div class="addIcon">
          <font-awesome-icon class="icon" icon="plus" />
          <font-awesome-icon class="iconBig" icon="user" />                
        </div>
      </div>
      <div class="cardList">
        <div 
          v-for="(cleaner, index) in cleanerInfo"
          :key="index">
          <br/>
          <ProfileCard
            :profileDetails="cleaner"
            @show-assign-units-checklist="showAssignUnits"/>
        </div>        
      </div>
      <b-modal id="register-cleaner" hide-footer>
        <template v-slot:modal-title>{{ $t('addCleaner') }}</template>
        <RegisterCleaner @success-add-cleaner="fetchCleaner"/>
      </b-modal>
   		<b-modal
        id="assign-units-checklist"
        size="lg"
        body-class="hide-padding"
        hide-footer
        no-stacking
  		>
        <template v-slot:modal-title>
          {{selectedProfile.first_name}} {{selectedProfile.last_name}}
        </template>
        <div>
          <table class="responsive-table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">{{ $tc('unit', 1) }}</th>
                <th scope="col">{{ $t('fullAddress') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(unitData, index) of selectedProfile.units" :key="index">
                <th scope="row">
                  <input
                    type="checkbox"
                    data-qa="assignedToUnits"
                    v-model="unitData.checked"
                    @change="checkUnit(unitData)"
                  />
                </th>
                <td data-title="">{{unitData.name}}</td>
                <td data-title="">{{unitData.address}}, {{unitData.postal_code}} {{unitData.city}}, {{unitData.country}}</td>
              </tr>
            </tbody>
          </table>
        </div>
  		</b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'
// import RegisterSupport from '@/components/ui/RegisterSupport.vue'
import RegisterCleaner from '@/components/ui/RegisterCleaner.vue'
import ProfileCard from '@/components/ui/ProfileCard.vue'


//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

import { mapState } from 'vuex'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('team'),
    }
  },
  components: {
    // RegisterSupport,
    RegisterCleaner,
    ProfileCard
  },
  computed: mapState(['unit']),
  data() {
    return {
      isEditing: false,
      isLoading: true,
      products: [],
      prodInfo: null,
      loading: true,
      errored: false,
      cleanerInfo: [],
      selectedProfile: [],
      selectedUnits: null
    }
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/dashboard`)
      .then(response => {
        // handle success
        this.products = response.data.products.products
        this.isLoading = false
      })
      .catch(error => {
        // handle error
        console.log(error)
      })
  },
  mounted() {
    this.fetchCleaner()
  },
  methods: {
    changeClientDetails() {
      if (
        confirm('are you sure? This will rewrite your excisting account details')
      ) {
        this.$store.dispatch('client/editClient', this.id)
      }
    },
    deleteCleaner() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('cleaner/removeCleaner', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    },
    fetchCleaner() {
      axios
      .get(`${process.env.VUE_APP_API_URL}/teamMembers`)
      .then(response => {
        this.cleanerInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
    },
    showAssignUnits(profileData) {
      this.selectedProfile = profileData
   		this.$bvModal.show('assign-units-checklist')
    },
    checkUnit() {
      const filteredUnits = this.selectedProfile.units.filter(singleUnit => {
        return (singleUnit.checked === true)
      })
      const unitIds = filteredUnits.map(unit => unit.id)
      this.$store.dispatch('cleaner/editCleaner', { cleaner_id: this.selectedProfile.id, unit_ids: JSON.stringify(unitIds) })
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    },
    cleaner: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fullWidth {
	width: 100%;
}
.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  border-radius: 5px;
  width: 30%;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.cardList {
  display: flex;
  flex-flow: wrap;
  width:auto;
}

// add button CSS sytling//
.addBtnWrapper {
  background-color: var(--bright);
  color: var(--bg);
  width: 10%;
  padding: 10px;
  margin: 20px;
  border-radius: 10px;
}
.addBtnWrapper:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--primaryDark);
  color: var(--bright);
  transition: 0.25s box-shadow, 0.25s transform;
}
.addBtnWrapper:hover {
  background-color: var(--primaryDark);
  color: var(--bright);
}
.addBtnWrapper1 {
  background-color: var(--primaryDark);
  color: var(--bright);
  width: 10%;
  padding: 10px;
  margin: auto;
  border-radius: 10px;
}
.addBtnWrapper1:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--bright);
  color: var(--bg);
  transition: 0.25s box-shadow, 0.25s transform;
}
.addBtnWrapper1:hover {
  background-color: var(--bright);
  color: var(--bg);
}
.iconBig {
  font-size: 1.4rem;
}

@media screen and (max-width: 900px) {
.cardList {
  flex-direction: column;
}
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
.addBtnWrapper {
  width: 25%;
}
}
</style>